import React from 'react';
import PropTypes from 'prop-types';
import UiKitButton from 'components/UiKit/Button';

const DeleteModalTrigger = ({
  isCreateScreen = false,
  redirectPath = '',
  openModal,
  setRedirect
}) => {
  return (
    <div>
      <UiKitButton
        variant="primary"
        ghost
        data-testid={isCreateScreen ? `cancelButton` : `deleteButton`}
        onClick={
          isCreateScreen
            ? () => {
                setRedirect(redirectPath);
              }
            : openModal
        }
      >
        {isCreateScreen ? 'Cancel' : 'Delete'}
      </UiKitButton>
    </div>
  );
};

DeleteModalTrigger.propTypes = {
  isCreateScreen: PropTypes.bool,
  redirectPath: PropTypes.string,
  setRedirect: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired
};

export default DeleteModalTrigger;
